'use strict';
/* eslint-disable no-mixed-operators */

var _slicedToArray = require("/root/project/node_modules/@babel/runtime/helpers/slicedToArray.js");

module.exports = function (red, green, blue, alpha) {
  var isPercent = (red + (alpha || '')).toString().includes('%');

  if (typeof red === 'string') {
    var _red$match$map = red.match(/(0?\.?\d{1,3})%?\b/g).map(Number);

    var _red$match$map2 = _slicedToArray(_red$match$map, 4);

    red = _red$match$map2[0];
    green = _red$match$map2[1];
    blue = _red$match$map2[2];
    alpha = _red$match$map2[3];
  } else if (alpha !== undefined) {
    alpha = parseFloat(alpha);
  }

  if (typeof red !== 'number' || typeof green !== 'number' || typeof blue !== 'number' || red > 255 || green > 255 || blue > 255) {
    throw new TypeError('Expected three numbers below 256');
  }

  if (typeof alpha === 'number') {
    if (!isPercent && alpha >= 0 && alpha <= 1) {
      alpha = Math.round(255 * alpha);
    } else if (isPercent && alpha >= 0 && alpha <= 100) {
      alpha = Math.round(255 * alpha / 100);
    } else {
      throw new TypeError("Expected alpha value (".concat(alpha, ") as a fraction or percentage"));
    }

    alpha = (alpha | 1 << 8).toString(16).slice(1);
  } else {
    alpha = '';
  }

  return (blue | green << 8 | red << 16 | 1 << 24).toString(16).slice(1) + alpha;
};
/* eslint-enable no-mixed-operators */